import axios from 'axios'
import { AuthXInterceptor } from '../Config/AuthXInterceptor'

 
 
export const voucherBXService = {
  // Get all vouchers
  index: async (params?: { page?: number; limit?: number; sortOrder?: 'ASC' | 'DESC' }) => {
    return AuthXInterceptor.get('vouchers', {
      params, 
    })
  },

  // Get single voucher
  show: async (voucherId: string) => {
    return AuthXInterceptor.get(`vouchers/${voucherId}`)
  },
}
